import React from 'react'
import PropTypes from 'prop-types'

function StepHeading({ children }) {
  return (
    <h3 className="quincy bold lh-44 leading-10 my-12 px-16 text-left text-40 md:my-16 md:text-center">
      {children}
    </h3>
  )
}

StepHeading.propTypes = {
  children: PropTypes.any.isRequired,
}

export default StepHeading
